// extracted by mini-css-extract-plugin
export default {"component":"style_component__SI35x","title":"style_title__dhv9L","listItems":"style_listItems__BRvfK"};